// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export const SDK_VERSION: string = "1.10.3";

export const DEFAULT_RETRY_POLICY_COUNT = 3;
